import { InspectionImageType } from "@/enums/InspectionImage.enum";
import { Images } from "@/features/components/Images/Images";
import { FileDetails, Image } from "@/types/Image.type";
import { DynamicComponentProps } from "@/types/ModuleComponentProp.type";
import { useEffect } from "react";

export const FullProductImages: React.FC<DynamicComponentProps> = ({ inspection, fullProductImageHandlers }: DynamicComponentProps) => {
    // const urls = inspection?.fullProductImageUrls ? inspection?.fullProductImageUrls?.split(',') : [];
    // const [isModified, setIsModified] = useState(false);
    // const [images, setImages] = useState<Image[]>(urls.map(u => ({ id: generateUniqueId(), url: u, type: InspectionImageType.FULL_PRODUCT })) || []);
    // const [newImages, setNewImages] = useState<Image[]>([]);

    // useEffect(() => {
    //     addImages();
    //     async function addImages() {
    //         if (isModified) {
    //             for (const newImg of newImages) {
    //                 try {
    //                     if (!newImg?.data) continue;
    //                     const res = await imageStorage.setImage(inspection?.id || '', InspectionImageType.FULL_PRODUCT, newImg.id, newImg.data);
    //                     // debugger;
    //                     console.log('Image added respnse', JSON.stringify(res));
    //                 } catch (error) {
    //                     console.error('Failed to add image in IndexDB', error);
    //                 }
    //             }
    //             store.dispatch(updateOpenedInspection({
    //                 fullProductImageUrls: images.map(i => i.url).join(','),
    //                 newImages: newImages?.map(i => ({ ...i, data: '' })), // do not store image data with the inspection
    //             }));
    //             setIsModified(false);
    //         }
    //     }
    // }, [saveSignal])


    useEffect(() => {
        if (fullProductImageHandlers?.loadImages) {
            fullProductImageHandlers.loadImages();
        }
    }, []);

    // useEffect(() => {
    //     loadImages();


    //     async function loadImages() {
    //         const images: Array<Image> = [];
    //         if (inspection?.fpImages?.length) {
    //             for (const imgInfo of inspection.fpImages) {
    //                 const img = await imageStorage.getImage(inspection.id, InspectionImageType.FULL_PRODUCT, imgInfo.id);
    //                 images.push({ id: imgInfo.id, data: img, type: InspectionImageType.FULL_PRODUCT });
    //             }
    //             // setNewImages(images);
    //         }
    //     }
    // }, []);
    async function onAdd(file: FileDetails): Promise<void> {
        // setIsModified(true);
        if (fullProductImageHandlers?.onAdd) {
            const newImage = { type: InspectionImageType.FULL_PRODUCT, isNew: true, ...file };
           
            // setNewImages(prev => [...prev, newImage]);
            fullProductImageHandlers.onAdd(newImage); // let the module rendere take care of image data
        }
    }

    async function onRemove(img: Image): Promise<void> {
        // if (images?.some(i => i.id === id)) {
        //     setImages(prev => prev.filter(i => i.id != id));
        // } else if (newImages?.some(i => i.id === id)) {
        //     setNewImages(prev => prev.filter(i => i.id != id));
        //     await imageStorage.removeImage(inspection.id, InspectionImageType.FULL_PRODUCT, id,);

        // }
       
        if (fullProductImageHandlers?.onDelete) {
            fullProductImageHandlers.onDelete(img);
        }
    }
    // const allImages = [...images, ...newImages];
    return <Images type={InspectionImageType.FULL_PRODUCT} inspectionId={inspection?.id || ''} images={inspection.fpImages || []} onAdd={onAdd} onRemove={onRemove} requirePortraitOrientation />
}